export const routesConfig = {
  root: ':type/:id',
  routes: [
    {
      path: '',
      loadComponent: () => import('./Landing'),
    },
  ],
};
